import { useTranslation } from "react-i18next";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";

export const BasicExamType = () => {
	const { t } = useTranslation();
	return (
		<Tooltip title={t("tooltips.basicExamType")}>
			<div className="menu-icon-button flex-center-row p-6 border-radius-6">
				<PickerNewItem className="icon-small" />
			</div>
		</Tooltip>
	);
};
